'use client';

import { ReactNode, useMemo } from 'react';

import { FeatureFlagContext } from './context';

type FeatureFlagProviderProps = {
    flags: ReadonlySet<string>;
    children: ReactNode;
};

export function FeatureFlagProvider({
    children,
    flags,
}: FeatureFlagProviderProps) {
    const contextValue = useMemo(
        () => ({
            isEnabled: (flag: string) => flags.has(flag.toUpperCase()),
        }),
        [flags]
    );

    return (
        <FeatureFlagContext.Provider value={contextValue}>
            {children}
        </FeatureFlagContext.Provider>
    );
}
